import React from 'react'
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import LinearProgress from 'material-ui/LinearProgress'
import Snackbar from 'material-ui/Snackbar'
import { TextField } from 'redux-form-material-ui'
import { Field, change } from 'redux-form'
import S3Uploader from '../../../S3Uploader'
import { getS3Url } from '../../../../utils/utils'
import ImagePlaceholder from './image_placeholder.png'

const styles = {
  imageWrapper: {
    textAlign: 'center',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '300px',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
  progress: (progressVisible => ({
    display: (progressVisible ? 'block' : 'none'),
  })),
}

class PhotoPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      completed: 0,
      progressVisible: false,
      updateImageSnackbarOpen: false,
    }
  }

  handlePreProcess = (file, next) => {
    this.setState({ progressVisible: true })
    next(file)
  }
  handleProgress = (percent, message) => {
    this.setState({ completed: percent })
    console.log(`Upload progress: ${percent}% ${message}`)
  }
  handleFinish = (response, fileName) => {
    const url = getS3Url(fileName)
    this.setState({ progressVisible: false,
      completed: 0,
      updateImageSnackbarOpen: true,
      image_url: url })
    this.props.change(`image_${this.props.mission_page.id}`, url)

    console.log(`Upload finished: ${url}`)
  }
  handleError = (message) => {
    console.log(`Upload error: ${message}`)
  }

  _openFileDialog = () => {
    this.fileUpload.click()
  }

  render() {
    const { mission_page } = this.props
    return (
      <div>
        <div style={styles.imageWrapper} >
          <img
            src={this.state.image_url || ImagePlaceholder}
            style={styles.image} alt="foto de perfil"
          />
        </div>
        <br />
        <Row>
          <Col xs="6" xs-offset="3">
            <LinearProgress
              color="#f79410"
              style={styles.progress(this.state.progressVisible)}
              mode="determinate" value={this.state.completed}
            />
          </Col>
        </Row>
        <br />
        <RaisedButton
          label="Elegir Imagen"
          onClick={this._openFileDialog} primary
          fullWidth
        />
        <S3Uploader
          ref={(input) => { this.fileUpload = input }}
          handleFinish={this.handleFinish}
          handleProgress={this.handleProgress}
          handlePreProcess={this.handlePreProcess}
          handleError={this.handleError}
          id={mission_page.id}
        />
        <Field
          ref={(input) => { this.lngInput = input }}
          name={`image_${mission_page.id}`}
          component={TextField}
          style={{ display: 'none' }}
        />
        <Snackbar
          open={this.state.updateImageSnackbarOpen}
          message={'Imagen procesada correctamente'}
          action={'OK'}
          autoHideDuration={1500}
          onRequestClose={this.handleSnackbarClose}
        />
      </div>
    )
  }

}

PhotoPage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
  change: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) => {
    dispatch(change('MissionAnswerForm', field, value))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(PhotoPage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/PhotoPage/index.jsx